
import {
  coAuthor,
  ParticipantAbstract,
} from "@/models/events/abstracts/ParticipantAbstract.model";
import { defineComponent, ref, computed, onMounted, reactive } from "vue";
import { loaderStart, loaderDone } from "@/services/Loader";
import { useStore } from "vuex";
import abstract from "@/store/abstract/actions";
import { toBase64 } from "@/services/FileToBase64";
import { showMessage } from "@/services/MessageService";
import { i18n } from "@/i18n";
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const registerAbstract = ref<ParticipantAbstract>({
      eventID: "",
      participantID: "",
      email: "",
      fullName: "",
      institution: "",
      coAuthors: [],
      title: "",
      format: "",
      summary: "",
      method: "",
      result: "",
      discussion: "",
      conclusion: "",
      bibliography: "",
      file: "",
      status: "pending",
    });
    const savedFile = ref<any>(null);
    const titleFile = ref("");
    const detailsAreVisible = ref(false);
    const coAuthorName = ref("");
    const coAuthorLastName = ref("");
    const coAuthorCountry = ref("");
    const coAuthorCity = ref("");
    const firtsCo = ref(true);
    const coauthors: Array<coAuthor> = reactive([]);
    const router = useRouter();
    const logged = computed(() => {
      return store.getters["user/isLogged"];
    });

    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });

    const participantData = computed(() => {
      return store.getters["user/participantData"];
    });
    const validateFormCoAuthors = computed(() => {
      if (
        coAuthorName.value.length &&
        coAuthorLastName.value.length &&
        coAuthorCountry.value.length &&
        coAuthorCity.value.length
      ) {
        return true;
      } else {
        return false;
      }
    });
    const validateForm = computed(() => {
      if (validatePermissionsParticipant()) {
        if (
          registerAbstract.value.fullName.length &&
          registerAbstract.value.institution.length &&
          registerAbstract.value.title.length &&
          registerAbstract.value.format.length &&
          registerAbstract.value.summary.length &&
          registerAbstract.value.method.length &&
          registerAbstract.value.result.length &&
          registerAbstract.value.discussion.length &&
          registerAbstract.value.conclusion.length &&
          registerAbstract.value.bibliography.length &&
          registerAbstract.value.file.length
        ) {
          if (validateFormCoAuthors.value) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    const addCoAuthor = async () => {
      const newCoAuthor: coAuthor = {
        name: coAuthorName.value,
        lastName: coAuthorLastName.value,
        country: coAuthorCountry.value,
        city: coAuthorCity.value,
      };
      coauthors.push(newCoAuthor);
      cleanListCoAuthors();
    };
    function validatePermissionsParticipant() {
      if (logged.value && participantData.value) {
        if (eventData.value.id === participantData.value.eventID) {
          if (participantData.value.status === "paid") {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    function cleanListCoAuthors() {
      coAuthorName.value = "";
      coAuthorLastName.value = "";
      coAuthorCountry.value = "";
      coAuthorCity.value = "";
    }
    function cleanForm() {
      registerAbstract.value.eventID = "";
      registerAbstract.value.participantID = "";
      registerAbstract.value.email = "";
      registerAbstract.value.fullName = "";
      registerAbstract.value.institution = "";
      registerAbstract.value.coAuthors = [];
      registerAbstract.value.title = "";
      registerAbstract.value.format = "";
      registerAbstract.value.summary = "";
      registerAbstract.value.method = "";
      registerAbstract.value.result = "";
      registerAbstract.value.discussion = "";
      registerAbstract.value.conclusion = "";
      registerAbstract.value.bibliography = "";
      registerAbstract.value.file = "";
      savedFile.value.value = "";
      firtsCo.value = true;
      detailsAreVisible.value = false;
      titleFile.value = "";
      coauthors.splice(0, coauthors.length);
    }
    const setFileAbst = async (file) => {
      if (file) {
        if (file.size < 5000_000) {
          const isPdf = file.type === "application/pdf";
          if (isPdf) {
            const pdfDataURL: any = await toBase64(file);
            registerAbstract.value.file = pdfDataURL;
            titleFile.value = file.name;
            detailsAreVisible.value = true;
          }
        } else {
          showMessage({
            title: i18n.global.t("register.profileImageSizeError.title"),
            message: i18n.global.t("register.profileImageSizeError.message"),
            type: "error",
          });
        }
      }
    };
    const saved = async () => {
      loaderStart();
      let participantAbst = {};
      registerAbstract.value.uid = participantData.value.uid;
      registerAbstract.value.eventID = eventData.value.id;
      registerAbstract.value.participantID = participantData.value.uid;
      registerAbstract.value.email = participantData.value.email;
      registerAbstract.value.coAuthors = coauthors;
      participantAbst = {
        ...registerAbstract.value,
        eventID: eventData.value.id,
        eventName: eventData.value.name,
        profileImage: participantData.value.profileImage,
        registerDate: new Date(),
      };
      await abstract.uploadAbstract(participantAbst);
      loaderDone();
      cleanForm();
      router.push({
        name: "Home",
        params: { eventID: eventData.value.id },
      });
    };
    return {
      registerAbstract,
      savedFile,
      coauthors,
      firtsCo,
      coAuthorName,
      coAuthorLastName,
      coAuthorCountry,
      coAuthorCity,
      saved,
      validateForm,
      validateFormCoAuthors,
      addCoAuthor,
      validatePermissionsParticipant,
      setFileAbst,
      cleanForm,
      titleFile,
      detailsAreVisible,
    };
  },
};
